export default "__VITE_ASSET__VHlOXX6v__"